<nz-card class="round-border p-4" [nzLoading]="!loaded">
	<a [routerLink]="['/role']">
		<nz-statistic
			[nzValue]="count | number"
			[nzTitle]="'role_common_name' | translate"
		></nz-statistic>
	</a>
</nz-card>
